import role from './role';

export default function(spec) {
  return {
    marktype:    spec.type,
    name:        spec.name || undefined,
    role:        spec.role || role(spec),
    zindex:      +spec.zindex || undefined
  };
}



// WEBPACK FOOTER //
// ./~/vega-parser/src/parsers/marks/definition.js